import { type IAcademicUnit } from './AcademicUnit'
import { type ICreatedBy, type DataObjectList, type IOwnedBy, type IModifiedBy, type DataObject } from './DataObject'
import { type ITerm } from './Term'
import { type ILinkedSection } from './TermsSection'

export enum SlotStatus {
  Draft = 'Draft',
  Published = 'Published',
  Live = 'Live',
  Closed = 'Closed'
}
export interface ISlotNodeDetails {
  courseCount: number
  slotStatus: SlotStatus
  studentCount: number
}
export interface ISurveyTemplate {
  title: string
  templateId: string
  templateRevision: number
}

export interface ISlotDateSettings {
  enabled: boolean
  noOfDays: number
  sectionFieldType: string
  slotId: string
  slotNodeSurveyDateSettingId: string
  surveyDateType: string
};

export interface InstructorAddedQuestions {
  isCustomQuestionAllowed?: boolean
  questionCount?: number
  isInstructorOptOutAllowed?: boolean
}

export interface AcademicLevelAddedQuestions {
  academicUnitCategories: IAcademicUnit[]
  isAcademicLevelOptOutAllowed?: boolean
  isCustomQuestionAllowed: boolean
  questionCount: number
}

export interface AcademicUnit {
  abbrevation: string
  categoryName: string
  depth: number
  divisionId: string
  title: string
}

export interface ISlot extends ICreatedBy, IOwnedBy, IModifiedBy {
  isArchived: boolean
  releaseTimestamp: Date | string
  slotStartTimestamp: Date
  slotEndTimestamp: Date
  slotCloseTimestamp: string
  slotId: string
  slotLiveTimestamp: string | null
  slotNodeDetails: ISlotNodeDetails
  slotTypeId: string | null
  surveyTemplate: ISurveyTemplate | null
  term: ITerm
  title: string
  slotDateSettings: ISlotDateSettings[]
  isCourseAttributeFilterActive: boolean
  isReportingHierarchyFilterActive: boolean
  isSyncAllSectionsForTermActive: boolean
  minimumEnrollment: boolean
  isInstructorAddedQuestionsAllowed?: boolean | null
  isAcademicLevelAddedQuestionsAllowed?: boolean | null
  instructorAddedQuestions?: InstructorAddedQuestions | null
  academicLevelAddedQuestions?: AcademicLevelAddedQuestions | null
  linkedSection?: ILinkedSection
  academicUnits: AcademicUnit[]
  isRollingResultsEnabled: boolean
}

export type IDistributionPlanRow = ISlot

export type IDistributionPlanList = DataObject<ISlot>

export type IDistributionPlanRowDataType = IDistributionPlanList[]

export type IDistributionPlan = DataObjectList<ISlot>
